import AdminStoreAdd from './AdminStoreAdd';
export default AdminStoreAdd;
